'use strict';

var react = require('react');

/**
 * SSR has issues with useLayoutEffect, so use useEffect during SSR.
 */ const useSafeLayoutEffect = typeof window === 'undefined' || typeof document === 'undefined' ? react.useEffect : react.useLayoutEffect;

exports.useSafeLayoutEffect = useSafeLayoutEffect;
//# sourceMappingURL=useSafeLayoutEffect.js.map
